export const pattern6Data = [
  {
    id: 1,
    koreanChunks: [
      "새로운 기술을 도입하는것이",
      "도움이 될 것입니다",
      "회사의",
      "생산성을",
      "향상시키는데",
    ],
    englishChunks: [
      "Implementing new technology",

      "will help",
      "the company's",
      "productivity",
      "improve",
    ],
    fullEnglish:
      "Implementing new technology will help improve the company's productivity.",
    explanation: "동명사구가 주어로 사용된 긴 주어 문장입니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "우리의 분기 매출이",
      "기대를 초과했다는 것은",

      "좋은 소식이다",
      "주주들에게",
    ],
    englishChunks: [
      "That our quarterly revenue",
      "has exceeded expectations is",

      "great news",
      "for shareholders",
    ],
    fullEnglish:
      "That our quarterly revenue has exceeded expectations is great news for shareholders.",
    explanation: "That절이 주어로 사용된 긴 주어 문장입니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "재택근무가",
      "직업만족도를 향상시켰다는 것",
      "입증됩니다",
      "설문조사 결과로",
    ],
    englishChunks: [
      "That remote work",
      "has improved employee satisfaction",
      "is supported",
      "by survey results",
    ],
    fullEnglish:
      "That remote work has improved employee satisfaction is supported by survey results.",
    explanation: "That절이 주어로 사용된 긴 주어 문장입니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "직원이",
      "그...더 경험이 많은",
      "다른 사람보다",
      "그 일을 맡게 되었다",
    ],
    englishChunks: [
      "An employee",
      "more experienced",
      "than others",
      "was chosen for the task",
    ],
    fullEnglish:
      "An employee more experienced than others was chosen for the task.",
    explanation:
      "비교급을 포함한 형용사구가 주어를 수식하는 긴 주어 문장입니다.",
  },

  {
    id: 5,
    koreanChunks: [
      "새로운 정책은",
      "그 .. 설계된",
      "향상시키기 위해 직장 효율성을 ",
      "시행될 것이다",
      "다음 달에",
    ],
    englishChunks: [
      "A new policy",
      "designed ",
      "to improve workplace efficiency",
      "will be implemented",
      "next month",
    ],
    fullEnglish:
      "A new policy designed to improve workplace efficiency will be implemented next month.",
    explanation:
      "과거분사구(designed to...)가 주어를 수식하는 긴 주어 문장입니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "제품은",
      "그 ... 디자인된",
      "니즈를 충족하도록",
      "환경을 고려하는 소비자의",
      "얻고 있는 중이다",
      "인기를",
    ],
    englishChunks: [
      "A product",
      "designed",
      " to meet the needs",
      "of eco-conscious consumers",
      "is gaining",
      "popularity",
    ],
    fullEnglish:
      "A product designed to meet the needs of eco-conscious consumers is gaining popularity.",
    explanation:
      "과거분사구(designed to...)가 주어를 수식하는 긴 주어 문장입니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "엔지니어가",
      "그 ... 익숙한",
      "최신 AI 기술에",
      "채용되었다",
      "회사에",
    ],
    englishChunks: [
      "An engineer",
      "familiar with",
      "the latest AI technologies",
      "has been hired",
      "by the company",
    ],
    fullEnglish:
      "An engineer familiar with the latest AI technologies has been hired by the company.",
    explanation:
      "형용사구(familiar with...)가 주어를 수식하는 긴 주어 문장입니다.",
  },
  {
    id: 8,
    koreanChunks: [
      "교육 프로그램은",
      "그 ... 목표로 하는",
      "리더십 기술 개발을",
      "제공될 것이다",
      "모든 직원에게",
    ],
    englishChunks: [
      "A training program",
      "aimed at",
      "developing leadership skills",
      "will be offered",
      "to all employees",
    ],
    fullEnglish:
      "A training program aimed at developing leadership skills will be offered to all employees.",
    explanation:
      "과거분사구(aimed at...)가 주어를 수식하는 긴 주어 문장입니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "모든 필수 서류가 제출되지 않으면",
      "신청이",
      "처리되지 않을 것이다",
    ],
    englishChunks: [
      "Unless all required documents are submitted,",
      "the application",
      "will not be processed",
    ],
    fullEnglish:
      "Unless all required documents are submitted, the application will not be processed.",
    explanation: "Unless로 시작하는 조건절이 있는 긴 주어 문장입니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "많은 직원이 재택근무를 선호하지만",
      "몇몇은 아직",
      "근무하기도 한다",
      "사무실에서",
    ],
    englishChunks: [
      "While many employees prefer remote work,",
      "some still",
      "choose to work",
      "from the office",
    ],
    fullEnglish:
      "While many employees prefer remote work, some still choose to work from the office.",
    explanation: "While로 시작하는 양보절이 있는 긴 주어 문장입니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "회사는",
      "제공하고 있다",
      "추가 교육 세션을 ",
      "그래서 직원들이 향상할 수 있도록",
      " 그들의 기술을",
    ],
    englishChunks: [
      "The company",
      "is offering",
      "additional training sessions",
      "so that employees can improve ",
      "their skills",
    ],
    fullEnglish:
      "The company is offering additional training sessions so that employees can improve their skills.",
    explanation: "so that으로 시작하는 목적절이 있는 긴 주어 문장입니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "이니셔티브가",
      "그...  초점을 맞춘",
      "향상시키는데 - 직원참여를",

      "개발되고 있다",
      "인사부에 의해",
    ],
    englishChunks: [
      "An initiative",
      "focused on",
      "enhancing employee engagement",
      "is being developed",
      "by HR",
    ],
    fullEnglish:
      "An initiative focused on enhancing employee engagement is being developed by HR.",
    explanation: "긴 주어와 수동태가 결합된 문장입니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "가장 적합한 지원자",
      "그...팀장 직책에 ",
      "발표될 것이다 곧",
    ],
    englishChunks: [
      "The most qualified applicant",
      "for the position of team leader",
      "will be announced soon",
    ],
    fullEnglish:
      "The most qualified applicant for the position of team leader will be announced soon.",
    explanation: "긴 주어와 수동태가 결합된 문장입니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "임원",
      "그.. 이끌어온",
      "연구부서를",
      "5년 동안",
      "은퇴할 예정이다",

      "다음 달에",
    ],
    englishChunks: [
      "An executive",
      "who has been leading",
      "the research department",
      "for five years",
      "will retire",
      "next month",
    ],
    fullEnglish:
      "An executive who has been leading the research department for five years will retire next month.",
    explanation: "관계대명사절이 포함된 긴 주어 문장입니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "주민들",
      "그.....불만을 제기하는",
      "소음 공해에 대해",

      "제출했다",
      "청원서를",
      "시의회에",
    ],
    englishChunks: [
      "Residents",
      "complaining",
      "about noise pollution",
      "have submitted",
      "a petition",
      "to the city council",
    ],
    fullEnglish:
      "Residents complaining about noise pollution have submitted a petition to the city council.",
    explanation: "현재분사구가 포함된 긴 주어 문장입니다.",
  },

  {
    id: 16,
    koreanChunks: [
      "승객들",
      "그... 기다리는",
      "긴 줄을",
      "공항 보안 검색대에서",
      "무거운 짐을 가지고",
      "권장된다",
      "일찍 도착하는 것이",
    ],
    englishChunks: [
      "Passengers",
      "waiting",
      "in a long line",
      "at the airport security checkpoint",
      "with heavy luggage",
      "are advised",
      "to arrive early",
    ],
    fullEnglish:
      "Passengers waiting in a long line at the airport security checkpoint with heavy luggage are advised to arrive early.",
    explanation: "현재분사구가 포함된 긴 주어 문장입니다.",
  },

  {
    id: 17,
    koreanChunks: [
      "과학자들",
      "그... 수행하는",
      "획기적인 연구를",
      "재생 가능 에너지 솔루션에 대한",
      "대응하기 위해 기후변화에",
      "받았다",
      "상당한 정부 지원을",
    ],
    englishChunks: [
      "Scientists",
      "conducting",
      "groundbreaking research",
      "on renewable energy solutions",
      "to combat climate change",
      "have received",
      "significant government funding",
    ],
    fullEnglish:
      "Scientists conducting groundbreaking research on renewable energy solutions to combat climate change have received significant government funding.",
    explanation: "현재분사구가 포함된 긴 주어 문장입니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "사람들",
      "그..동네에 살고 있는",
      "그 ...대중교통이 부족",
      "그리고 교통 정체가 심한",
      "종종 어려움을 겪는다",
      "긴 출퇴근 시간을",
    ],
    englishChunks: [
      "People",
      "living in a neighborhood",
      "where public transportation is limited",
      "and traffic congestion is severe",
      "often struggle",
      "with long commutes",
    ],
    fullEnglish:
      "People living in a neighborhood where public transportation is limited and traffic congestion is severe often struggle with long commutes.",
    explanation: "현재분사구가 포함된 긴 주어 문장입니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "소비자들",
      "그... 쇼핑하는 몰에서",

      "그... 다양한 국제 브랜드와",
      "고급 제품을 구입할 수 있는",
      "즐긴다",
      "프리미엄 쇼핑 경험을",
    ],
    englishChunks: [
      "Consumers",
      "shopping in a mall",
      "where a wide variety of international brands and",
      "luxury goods are available",
      "enjoy",
      "a premium retail experience",
    ],
    fullEnglish:
      "Consumers shopping in a mall where a wide variety of international brands and luxury goods are available enjoy a premium retail experience.",
    explanation: "현재분사구가 포함된 긴 주어 문장입니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "고객들",
      "그... 최근 이사한",
      "다른 지역으로",
      "업데이트해야 합니다",
      "청구 주소를",
      "웹사이트에서",
    ],
    englishChunks: [
      "Customers",
      "who recently moved",
      "to a different neighborhood",
      "should update",
      "their billing address",
      "on our website",
    ],
    fullEnglish:
      "Customers who recently moved to a different neighborhood should update their billing address on our website.",
    explanation: "관계대명사절이 포함된 긴 주어 문장입니다.",
  },
  {
    id: 21,
    koreanChunks: ["고객 불만이 지난달에 증가한 이유는", "현재", "조사 중이다"],
    englishChunks: [
      "The reason why customer complaints have increased in the past month",
      "is currently",
      "under investigation",
    ],
    fullEnglish:
      "The reason why customer complaints have increased in the past month is currently under investigation.",
    explanation: "관계부사절이 포함된 긴 주어 문장입니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "제안서",
      "그... 제출된",
      "지난주 이사회에",
      "현재 검토되고 있다",
      "고위 임원들에 의해",
    ],
    englishChunks: [
      "The proposal",
      "which was submitted",
      "to the board last week",
      "is now being reviewed",
      "by senior executives",
    ],
    fullEnglish:
      "The proposal which was submitted to the board last week is now being reviewed by senior executives.",
    explanation: "관계대명사절이 포함된 긴 주어와 수동태가 결합된 문장입니다.",
  },
  {
    id: 23,
    koreanChunks: [
      "문서들",
      "그... 제출된",
      "인사부에 지난주",
      "현재 검토 되어지고 있다",
    ],
    englishChunks: [
      "Documents",
      "which were submitted",
      "to the human resources department last week",
      "are currently being reviewed",
    ],
    fullEnglish:
      "Documents which were submitted to the human resources department last week are currently being reviewed.",
    explanation: "관계대명사절이 포함된 긴 주어와 수동태가 결합된 문장입니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "소프트웨어",
      "그... 개발된",
      "강화하기 위해 데이터 보안을",
      "테스트 중이다",
      "공식 출시 전에",
    ],
    englishChunks: [
      "Software",
      "developed",
      "to enhance data security",
      "is being tested",
      "before its official release",
    ],
    fullEnglish:
      "Software developed to enhance data security is being tested before its official release.",
    explanation: "관계대명사절이 포함된 긴 주어와 수동태가 결합된 문장입니다.",
  },
  {
    id: 25,
    koreanChunks: [
      "보존 노력은",
      "그... 시작된",
      "환경 단체들에 의해",
      "보호하기 위해 멸종 위기 종을",

      "확대되고 있다",
      "전 세계적으로",
    ],
    englishChunks: [
      "Conservation efforts",
      "initiated",
      "by environmental organizations",
      "to protect endangered species",
      "are being expanded",
      "globally",
    ],
    fullEnglish:
      "Conservation efforts initiated by environmental organizations to protect endangered species are being expanded globally.",
    explanation: "관계대명사절이 포함된 긴 주어와 수동태가 결합된 문장입니다.",
  },
];
